export default __webpack_public_path__ + "static/2-4d9801150d3b8974aae479b4fa3989fe.png";